module.exports = __webpack_public_path__ + "static/media/282a1474-6d04-45e8-91b5-dd5e37484649.c37f93b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/282a1474-6d04-45e8-91b5-dd5e37484649.jpg
// module id = 808
// module chunks = 0